import { SetLoading } from "common/components/Loader/Loader";
import RobotsNoIndex from "common/components/RobotsNoIndex";
import { GetCurrentGamePrefix } from "common/constants/Games";
import { LocalStorageKeys } from "common/constants/StorageKeys";
import { changeUrl, consumeQueryParam } from "common/history";
import UserManager from "common/userManager";
import React from "react";
import { linkAccount } from "./api";

const LABELS = {
	discord: "Discord",
	google: "Google",
	reddit: "Reddit",
};

export default class LinkAccount extends React.Component {
	async componentDidMount() {
		const { provider } = this.props;
		SetLoading(true, `Linking ${LABELS[provider]} account`);

		let signedOut = false;
		const code = consumeQueryParam("code");
		if (code !== null) {
			try {
				await linkAccount(provider, code);
			} catch (error) {
				signedOut = error && error.status === 401;
			}
		}

		SetLoading(false);
		const redirect = localStorage.getItem(LocalStorageKeys.POSTLINKURL);
		if (redirect) {
			localStorage.removeItem(LocalStorageKeys.POSTLINKURL);
			changeUrl(redirect);
		} else {
			changeUrl(GetCurrentGamePrefix() + "/event");
		}

		if (signedOut) {
			UserManager.openLoginModal();
		}
	}

	render() {
		return <RobotsNoIndex />;
	}
}
